module.exports = __webpack_public_path__ + "files/deepcath.3002bc74dedbbf3325ea089da177addd.pdf";